module.exports = __webpack_public_path__ + "static/media/IMG_4255.92d4a265.PNG";